import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loading } from "@/components/common";
import { BrandLockup } from "@/components/brand";
import { clearStoredSelection } from "./patientContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ApoioLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <Loading label="Verificando sessão…" />;
  if (user) return <Navigate to="/apoio" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    // Novo login: a seleção anterior é descartada (usuários com vários pacientes escolhem de novo).
    clearStoredSelection();
    const result = await login(email, password);    setSubmitting(false);
    if (result.ok) navigate("/apoio");
    else setError(result.error);
  };

  return (
    <div data-testid="apoio-login-page" className="min-h-screen bg-bone">
      <div className="mx-auto flex min-h-screen max-w-md flex-col px-6 pb-24 pt-16">
        <BrandLockup size="lg" orientation="vertical" product="Rede de apoio" testId="apoio-login-brand" />
        <p className="er-label mt-8">Erimus – Rede de Apoio</p>
        <h1 className="mt-3 font-display text-3xl font-medium tracking-tight text-ink-900">Bem-vinda de volta</h1>
        <p className="mt-3 text-sm leading-relaxed text-ink-500">
          Você acessa apenas o que a coordenação clínica autorizou, para a pessoa que você acompanha.
        </p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <Label htmlFor="apoio-email" className="text-sm text-ink-600">
              E-mail
            </Label>
            <Input
              id="apoio-email"
              data-testid="apoio-email-input"
              type="email"
              value={email}
              autoComplete="username"
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 rounded-xl bg-white"
              required
            />
          </div>
          <div>
            <Label htmlFor="apoio-password" className="text-sm text-ink-600">
              Senha
            </Label>
            <Input
              id="apoio-password"
              data-testid="apoio-password-input"
              type="password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-12 rounded-xl bg-white"
              required
            />
          </div>

          {error ? (
            <p data-testid="apoio-login-error" role="alert" className="rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger">
              {error}
            </p>
          ) : null}

          <Button
            type="submit"
            data-testid="apoio-login-submit"
            disabled={submitting}
            className="h-12 w-full rounded-full bg-sage-600 text-bone hover:bg-sage-700"
          >
            {submitting ? "Entrando…" : "Entrar"}
          </Button>
        </form>

        <p className="mt-8 text-xs leading-relaxed text-ink-400">
          Recebeu um convite? Use o link enviado pela equipe para ativar sua conta e definir sua senha.
        </p>
      </div>
    </div>
  );
}
